import { render, staticRenderFns } from "./subject_form.vue?vue&type=template&id=6f239293&"
import script from "./subject_form.vue?vue&type=script&lang=js&"
export * from "./subject_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports